import { render, staticRenderFns } from "./PracticeBookingRequestsSent.vue?vue&type=template&id=17d264d1&"
import script from "./PracticeBookingRequestsSent.vue?vue&type=script&lang=js&"
export * from "./PracticeBookingRequestsSent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports